export const UserRole = {
  ADMINISTRATOR: 40,
  ROLLOUT_MANAGER: 30,
  TECHNICIAN: 20,
  SERVICE_DESK: 15,
  CLIENT: 10,
} as const;

export type UserRoleKeys = keyof typeof UserRole;
export type UserRoleValues = typeof UserRole[UserRoleKeys];

export const getUserRoleNames = () => {
  return Object.keys(UserRole);
}

export const getUserRoleByValue = (value: UserRoleValues) => {
  return Object.keys(UserRole).find(role => UserRole[role as UserRoleKeys] === value);
}